<template>
  <v-container
    :pa-3="$vuetify.breakpoint.xsOnly"
  >
    <v-layout>
        <search-form></search-form>
    </v-layout>
  </v-container>
</template>

<script>
  import mixinsPages from '@/mixins/pages'
  import SearchForm from '@/components/search/SearchForm'

  export default {
    title: 'Add New Tracking',
    mixins: [mixinsPages],
    components: {
      SearchForm
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/search/search-add.vue